import styled from 'styled-components';
import {
	Collapse,
	Drawer,
	ListItem,
	ListItemButton,
	ListItemText
} from '@mui/material';
import { colorTheme } from '@styles/muiTheme';

export const DrawerStyled = styled(Drawer)(
  ({ theme }) => `
    flex-shrink: 0;
    position: relative;
    z-index: 2;
    
    .MuiDrawer-paper {
      color: ${theme.palette.common.white};
      box-sizing: border-box;
      background-color: ${theme.palette.primary.main};
      width: ${theme.drawerWidth};
      
      &::-webkit-scrollbar {
        display: none;
      }
    };
  `
);

export const DrawerHeader = styled.div(
  ({ theme }) => `
  min-height: 85px;
  display: flex;
  font-size: 14px;
  font-weight: 600;
  position: relative;
  align-items: flex-start;
  gap: ${theme.spacing(1)};
  padding: ${theme.spacing(0, 2, 0, 3)};
  align-items: center;
`
);

export const UserAvatar = styled.div(
  ({ theme }) => `
  width: 32px !important;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100%;
  background: ${theme.palette.primary.light};
  margin-right: 5px;
`
);

export const MenuListItem = styled(ListItem)`
  padding: 0;
  align-items: flex-start;
  &:hover {
    background: ${colorTheme.palette.primary.light};
  }
`;

export const MenuListItemText = styled(ListItemText)`
  && {
    .MuiTypography-root {
      color: inherit;
      font-weight: inherit;
    }
  }
`;

export const MenuCollapseArea = styled(Collapse)(({ theme }) => `
  background: ${theme.palette.primary.dark};
`);

export const SidebarMenuSectionTitle = styled.div(
  ({ theme }) => `
  width: 100%;
  background: #3684b03d;
  padding: ${theme.spacing(1, 3)};
`,
);

export const MenuListItemButton = styled(ListItemButton).withConfig<{ isActive?: boolean, $hasAlert?: boolean, $alertColor?: string }>({
  shouldForwardProp: (prop) => prop !== 'isActive',
})(({ theme, isActive, $hasAlert, $alertColor }) => `
  padding: ${theme.spacing(1 / 2, 3)};

  ${isActive && `
    color: ${theme.palette.info.light};
    font-weight: 600;
  `};

  ${$hasAlert && `
    background: ${$alertColor ? $alertColor : ''};
    &:hover {
      background: ${$alertColor ? $alertColor : ''};
      opacity: 0.8;
    }
  `}
`);
